import {MovieService,FilmFestivalService, RegionService} from 'hasta-la-vista-middleware-api/service'
export default {
    props: {
        filmFestival: Object,
    },

    data(){
        return {
            loading: true,
        }
    },

    name: 'film-festival-list-item',
    methods: {
        continueToDetails(id) {
            this.$router.push('/film-festival-details/' + id);
        },
    },
    created() {
        // console.log('Film Festival list item');
    }
}



// WEBPACK FOOTER //
// ./src/components/exclusive-to-sk/film-festivals/film-festival-list-item.js